let initialState = {
	searching: false,
	results: []
};

export default function serviceReducer(state = initialState, action) {
	switch (action.type) {
		case 'SEARCH_REQUEST':
			return {
				searching: true
			};
		case 'SEARCH_SUCCESS':
			return {
				searching: false,
				results: action.results
			};
		case 'SEARCH_FAILURE':
			return {
				searching: false,
				results: []
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/serviceReducer.js